var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QuestionYesNo',{attrs:{"title":"Is Discrete","question":{ options: _vm.options, designator: 'is_discrete' },"initValue":_vm.initValue},on:{"input":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }